import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { AxiosError } from "axios";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Eye, Loader2 } from "lucide-react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Router, { useRouter } from "next/router";
import React, {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Marquee from "react-fast-marquee";
import { BiSolidHelpCircle } from "react-icons/bi";
import { BsGlobe } from "react-icons/bs";
import { FaBell, FaCheck } from "react-icons/fa";
import { MdClose, MdDarkMode, MdDone, MdLightMode } from "react-icons/md";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { useSidebarContext } from "@/contexts/SidebarContext";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { Turn as Hamburger } from "hamburger-react";
import Script from "next/script";
import { RiSettings5Fill } from "react-icons/ri";
import { useRecoilState } from "recoil";
import { brokerFlagState } from "../../Atoms/auth/BrokerFlag";
import { headerTradesState } from "../../Atoms/auth/HeaderTrades";
import Funds from "../../components/Funds";
import { API_URL } from "../../config";
import { useFunds } from "../../contexts/VfundsContext";
import {
  formatDateLocal,
  formatTrade,
  Pagination,
  useToastHelper,
} from "../../helpers/helperFunctions";

import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { CardContent, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Dialog, DialogContent } from "../ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

import { Label } from "../ui/label";
import { ScrollArea } from "../ui/scroll-area";
import { Separator } from "../ui/separator";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { useQuickStrategyContext } from "@/contexts/QuickStrategyContext";
import { useUpgradePlanModal } from "@/contexts/UpgradePlanModalContext";
import ViewModal from "@/sections/build/components/StrategyViewModal";
import dotenv from "dotenv";
import { IoMdClose } from "react-icons/io";
import { Textarea } from "../ui/textarea";
import CreateStrategyForm from "../common/CreateStrategyForm";
import { technicalSupportModalAtom } from "@/Atoms/modal/DialogueAtoms";
import { useGetLiveDeploymentStats } from "@/api/strategyApi";
import { useUserContext } from "@/contexts/userContext";
import {
  useGetUserAllNotification,
  useGetUserNotification,
  usePostReadDeploymentNotification,
  usePostSetLanguagePref,
} from "@/api/userApi";
import Image from "next/image";
import { BROKER_LOGO, CURRENT_BROKER } from "@/config/logos";

Chart.register(
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface IHeaderProps {
  publicMenu?: ReactNode;
  sticky?: boolean;
  blur: boolean;
  checked: boolean;
  icons: boolean;
  hideHeader?: boolean;
  onScrollBg?: boolean;
  showInfo?: boolean;
  toggleUserMenu: (val: boolean) => void;
  showDisabled?: boolean;
}

const frameworks: any = [];

const NOTIFICATION_LIMIT = 5;

export default function Header(props: IHeaderProps) {
  dotenv.config();

  const { toast } = useToastHelper();
  const { showSidebar, setShowSidebar } = useSidebarContext();
  const { userType } = useSubscription();
  const { changeScannerType, setQuickStrategyModalToggle, openQuickStrategy } =
    useQuickStrategyContext();
  const { darkTheme, setDarkTheme } = useDarkTheme();
  const { user: userInfo } = useUserContext();
  const router = useRouter();
  const { t } = useTranslation("layout");
  const [showInteractiveTour, setShowInteractiveTour] = useState(false);
  const [showBacktestReportGuide, setShowBacktestReportGuide] = useState(false);
  const [showRedDot, setShowRedDot] = useState<boolean>(false);
  const [showNotificationMenu, setShowNotificationMenu] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [alertTotalCount, setAlertTotalCount] = useState(0);
  const [createdTotalCount, setCreatedTotalCount] = useState(0);
  const [currentCreatedPage, setCurrentCreatedPage] = useState(1);
  const [notification, setNotification] = useState([]);
  const [value, setValue] = React.useState("");
  const [showGuideModalNew, setShowGuideModalNew] = useState(false);
  const [headerTrades, setHeaderTrades] =
    useRecoilState<any>(headerTradesState);
  const [enabledSwitch, setEnabledSwitch] = useState(router.locale || "en");
  const selectedLanguage = useMemo(
    () => router.locale || enabledSwitch,
    [router.locale, enabledSwitch]
  );

  let [showPopup, setShowPopup] = useState(true);
  const [selected, setSelected] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const handleViewScanner = (
    canvasData: string,
    symbol: string,
    timeframe: string
  ) => {
    const parsedCanvasData = JSON.parse(canvasData) || {};
    setSelected({
      nodes: parsedCanvasData?.filter?.(
        (item: any) => item.type === "selectorNode"
      ),
      edges: parsedCanvasData?.filter?.(
        (item: any) => item.type === "buttonedge"
      ),
      symbol: symbol,
      timeframe: timeframe,
    });
    setShowModal(true);
  };
  const toastMessage = (status: boolean, message: string) => {
    if (status == true) {
      toast({
        title: message,
      });
      return;
    } else {
      toast({
        title: message,
        variant: "destructive",
      });
    }
    // throw new Error(message);
  };
  const [loading, setLoading] = useState(false);
  const [isStatus, setIsStatus] = useState(true);
  const [deploymentAlert, setDeploymentAlert] = useState([]);
  const { openUpgradePlanModal } = useUpgradePlanModal();
  const scrollRef = useRef<any>(null);
  const [showTechnicalRequest, setShowTechnicalRequest] = useRecoilState(
    technicalSupportModalAtom
  );

  const {
    data: liveDeploymentData,
    isLoading: liveDataLoading,
    isSuccess: liveDataSuccess,
  } = useGetLiveDeploymentStats(userInfo?.user_id);

  const {
    data: userNotificationData,
    isLoading: notificationLoading,
    isSuccess: notificationSuccess,
    isError: notificationError,
    error: notificationErrorData,
  } = useGetUserNotification(userInfo?.user_id, currentCreatedPage);
  const {
    data: allUserNotificationData,
    isLoading: allNotificationLoading,
    isSuccess: allNotificationSuccess,
    isError: allNotificationError,
    error: allNotificationErrorData,
  } = useGetUserAllNotification(userInfo?.user_id, currentCreatedPage);

  const { mutateAsync: readNotifications } =
    usePostReadDeploymentNotification();

  const {
    mutateAsync: saveLanguagePreference,
    data: saveLanguageData,
    isSuccess: saveLanguageSuccess,
  } = usePostSetLanguagePref();

  const handleNotificationClick = (userInfo: any) => {
    readNotifications(userInfo?.user_id);
  };

  useEffect(() => {
    if (userInfo?.preference.language) {
      setEnabledSwitch(userInfo.preference.language);
    } else {
      setEnabledSwitch("en");
    }
  }, []);

  const saveLanguagePref = async (language: any) => {
    await saveLanguagePreference({
      user_id: userInfo?.user_id,
      language_pref: language,
    });
    localStorage.setItem(
      "user-info",
      JSON.stringify({
        ...userInfo,
        preference: { ...userInfo?.preference, language },
      })
    );
    setEnabledSwitch(language || "en");
    router.push(router.asPath, undefined, { locale: language });
  };

  const getNameInitals = (user: any) => {
    if (
      userInfo &&
      userInfo?.user?.first_name?.length > 0 &&
      userInfo?.user?.first_name != ""
    ) {
      return (
        userInfo?.user.first_name?.[0]?.toUpperCase() +
        (userInfo?.user.last_name?.[0]?.toUpperCase() || "")
      );
    }
    return userInfo?.user?.email?.[0]?.toUpperCase?.() || "#";
  };

  const languagesOptions = useMemo(() => {
    return [
      {
        name: t("header.bahasaIndonesia"),
        value: "id",
      },
      {
        name: t("header.bahasaMalaysia"),
        value: "ms",
      },
      {
        name: t("header.chinese"),
        value: "zh",
      },
      {
        name: t("header.english"),
        value: "en",
      },
      {
        name: t("header.german"),
        value: "de",
      },
      {
        name: t("header.italian"),
        value: "it",
      },
      {
        name: t("header.portuguese"),
        value: "pt",
      },
      {
        name: t("header.spanish"),
        value: "es",
      },
      {
        name: t("header.thai"),
        value: "th",
      },
      {
        name: t("header.vietnamese"),
        value: "vi",
      },
    ];
  }, [t]);

  useEffect(() => {
    if (router?.query?.flag) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
      let { flag, ...query } = router.query;
      router.replace({ query }, void 0, { shallow: true });
    }
  }, [router]);

  useEffect(() => {
    if (saveLanguageSuccess && saveLanguageData) {
      toastMessage(true, saveLanguageData?.data.message);
    }
  }, [saveLanguageSuccess, saveLanguageData]);

  useEffect(() => {
    if (liveDataSuccess && liveDeploymentData?.data) {
      const result = {
        ...liveDeploymentData?.data,
        total_strategies: liveDeploymentData.data.total_strategies || 0,
        total_live_strategies:
          liveDeploymentData.data.total_live_strategies || 0,
        total_trades: liveDeploymentData.data.total_trades || 0,
        total_volume: liveDeploymentData.data.total_volume || 0,
        broker_win_p: liveDeploymentData.data.broker_win_p || 0,
        net_cumulative_profit:
          liveDeploymentData.data.net_cumulative_profit || 0,
        total_exposure: liveDeploymentData.data.total_exposure || 0,
        netPosition_broker:
          liveDeploymentData.data.broker_loss != null &&
          liveDeploymentData.data.broker_profit != null
            ? liveDeploymentData.data.broker_profit +
              liveDeploymentData.data.broker_loss
            : 0,
      };

      setHeaderTrades(result);
    }
  }, [liveDataSuccess, liveDataLoading, liveDeploymentData]);

  useEffect(() => {
    if (notificationSuccess && userNotificationData) {
      setNotification(userNotificationData?.data?.items);
      setCreatedTotalCount(userNotificationData?.data?.total);
      setShowRedDot(true);
    } else if (notificationError && notificationErrorData) {
      if (
        (notificationErrorData as AxiosError<{ detail: string }>)?.response
          ?.data?.detail ===
          "Please upgrade to the pro plan to access this feature" &&
        (window.location.pathname.includes("test") ||
          window.location.pathname.includes("deploy") ||
          window.location.pathname.includes("build"))
      ) {
        openUpgradePlanModal(true, "", null);
      }
    }
  }, [
    notificationSuccess,
    notificationError,
    notificationLoading,
    userNotificationData,
  ]);

  useEffect(() => {
    if (allNotificationSuccess && allUserNotificationData) {
      const prev = allUserNotificationData?.data?.items.map((item: any) => ({
        strategy_name: item?.strategy.strategy_name,
        deployment_id: item?.id,
        isDeployedAlerts: true,
      }));
      setAlertTotalCount(allUserNotificationData?.data?.total);
      setDeploymentAlert(prev);
    } else if (allNotificationError && allNotificationErrorData) {
      const e = allNotificationErrorData as AxiosError<{ detail: string }>;
      if (
        e?.response?.data?.detail ===
        "Please upgrade to the pro plan to access this feature"
      ) {
        toastMessage(false, e?.response?.data?.detail);
      }
      if (e?.response?.data?.detail == "Invalid Session. Please Login again.") {
        Router.push({ pathname: "/logout", query: Router.query }).then(() =>
          router.reload()
        );
      }
      console.error("error get_all_notification_deployments", e?.message);
    }
  }, [
    allNotificationError,
    allNotificationErrorData,
    allNotificationLoading,
    allNotificationSuccess,
  ]);

  return (
    <>
      <div
        className={`sm:sticky sm:top-0 z-50 bg-[hsl(var(--background))] ${
          props?.onScrollBg && "z-20 bg-[hsl(var(--background))] "
        } ${props?.showDisabled ? "pointer-events-none opacity-50" : ""}`}
      >
        {/* To show bar only on market place page */}
        {router?.pathname?.includes("marketplace") && showPopup && (
          <div className="p-[6px] pl-2 bg-[#3269CC] text-xs flex justify-between items-center">
            <div>
              These strategies are for educational purposes only, showcasing
              what's possible with Plus100. Please conduct your own research
              before making any trading decisions.
            </div>
            <div
              onClick={() => setShowPopup(false)}
              className="cursor-pointer h-full bold flex justify-center items-center  pr-1"
            >
              <IoMdClose />
            </div>
          </div>
        )}

        <Dialog
          open={showInteractiveTour}
          onOpenChange={setShowInteractiveTour}
        >
          <DialogContent className="max-w-screen-xl w-full">
            <div>
              <Script src="https://js.storylane.io/js/v1/storylane.js"></Script>
              <div className="sl-embed relative pb-[calc(50.84%+27px)] w-full h-0 scale-100">
                <iframe
                  className="sl-demo absolute top-0 left-0 w-full h-full border shadow-[0_0_18px_rgba(26,19,72,0.15)] rounded-lg box-border"
                  src="https://app.storylane.io/demo/z2rhljn2bflp"
                  name="sl-embed"
                  allow="fullscreen; camera; microphone"
                ></iframe>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={showBacktestReportGuide}
          onOpenChange={setShowBacktestReportGuide}
        >
          <DialogContent className="max-w-screen-xl w-full">
            <div>
              <Script src="https://js.storylane.io/js/v1/storylane.js"></Script>
              <div className="sl-embed relative pb-[calc(50.84%+27px)] w-full h-0 scale-100">
                <iframe
                  className="sl-demo absolute top-0 left-0 w-full h-full border shadow-[0_0_18px_rgba(26,19,72,0.15)] rounded-lg box-border"
                  src="https://app.storylane.io/demo/fbe5ywshwvfj"
                  name="sl-embed"
                  allow="fullscreen; camera; microphone"
                ></iframe>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          open={showGuideModalNew}
          onOpenChange={() => setShowGuideModalNew(false)}
        >
          <DialogContent className="max-w-screen-xl w-full">
            <div className="sl-embed relative mt-4 pb-[calc(50.84%+27px)] w-full h-0 scale-100">
              <iframe
                className="sl-demo absolute top-0 left-0 w-full h-full border shadow-[0_0_18px_rgba(26,19,72,0.15)] rounded-lg box-border"
                src="https://www.youtube.com/embed/9PQaKeFyV_A"
                name="sl-embed"
                allow="fullscreen; camera; microphone"
              ></iframe>
            </div>
          </DialogContent>
        </Dialog>

        <div className="flex flex-col xl:flex-row justify-between text-sm">
          <div className="xl:flex hidden flex-wrap">
            <div className="flex gap-2 items-center not-italic">
              <div className="text-sm text-muted-foreground">
                {t("header.liveTrading.totalStrategiesCreated")} :
              </div>
              <div className="text-[#316ACD]">
                {formatTrade(headerTrades?.total_strategies)}
              </div>
            </div>
            <Separator orientation="vertical" className="mx-2" />
            <div className="flex gap-2 items-center not-italic">
              <div className="text-sm text-muted-foreground">
                {t("header.liveTrading.totalTradesExecuted")} :
              </div>
              <div className="text-[#316ACD]">
                {formatTrade(headerTrades?.total_trades)}
              </div>
            </div>
            <Separator orientation="vertical" className="mx-2" />
            <div className="flex gap-2 items-center not-italic">
              <div className="text-sm text-muted-foreground">
                {t("header.liveTrading.totalLiveStrategies")} :
              </div>
              <div className="text-[#316ACD]">
                {formatTrade(headerTrades?.total_live_strategies)}
              </div>
            </div>
            <Separator orientation="vertical" className="mx-2" />
            <div className="flex gap-2 items-center not-italic">
              <div className="text-sm text-muted-foreground">
                {t("Total live deployments")} :
              </div>
              <div className="text-[#316ACD]">
                {formatTrade(headerTrades?.total_live_deployments)}
              </div>
            </div>
            <Separator orientation="vertical" className="mx-2" />
            <div className="flex gap-2 items-center not-italic">
              <div className="text-sm text-muted-foreground">
                {t("Live scanner deployments")} :
              </div>

              <div className="text-[#316ACD]">
                {formatTrade(headerTrades?.scanners_deployed)}
              </div>
            </div>
          </div>
          <div className="xl:hidden flex max-w-screen w-full grow p-2">
            <Marquee className="max-w-screen">
              <ul className="relative z-10 flex flex-row gap-5 text-sm mr-3">
                <li className="flex gap-2 items-center min-w-[12rem]">
                  <div className="text-sm text-muted-foreground">
                    {t("header.liveTrading.totalStrategiesCreated")} :
                  </div>
                  <div className="text-[#316ACD]">
                    {headerTrades?.total_strategies}
                  </div>
                </li>
                <li className="flex gap-2 items-center min-w-[12rem]">
                  <div className="text-sm text-muted-foreground">
                    {t("header.liveTrading.totalTradesExecuted")} :
                  </div>
                  <div className="text-[#316ACD]">
                    {headerTrades?.total_trades}
                  </div>
                </li>
                <li className="flex gap-2 items-center min-w-[6rem]">
                  <div className="text-sm text-muted-foreground">
                    {t("header.liveTrading.totalLiveStrategies")} :
                  </div>
                  <div className="text-[#316ACD]">
                    {headerTrades?.total_live_strategies}
                  </div>
                </li>
                <li className="flex gap-2 items-center min-w-[12rem]">
                  <div className="text-sm text-muted-foreground">
                    {t("Total live deployments")} :
                  </div>
                  <div className="text-[#316ACD]">
                    {headerTrades?.total_live_deployments}
                  </div>
                </li>
                <li className="flex gap-2 items-center min-w-[12rem]">
                  <div className="text-sm text-muted-foreground">
                    {t("Live scanner deployments")} :
                  </div>
                  <div className="text-[#316ACD]">
                    {headerTrades?.scanners_deployed}
                  </div>
                </li>
              </ul>
            </Marquee>
          </div>
          <div
            className="flex flex-row grow gap-2 justify-between mr-1 relative sm:mr-1"
            id="notificationMenu"
          >
            <div className="flex flex-row grow gap-2 justify-end items-center mr-1 relative sm:mr-1">
              <Link
                href={{
                  pathname: "https://trylevel2.gitbook.io/getting-started",
                }}
                target="_blank"
              >
                <BiSolidHelpCircle size={19} />
              </Link>
              <Badge
                onClick={() => {
                  setShowTechnicalRequest({
                    isOpen: true,
                    isRequest: false,
                    helpline: true,
                  });
                }}
                className="cursor-pointer "
              >
                {t("Technical support")}
              </Badge>
              <div
                className="flex justify-center items-center"
                id="languageMenu"
              >
                <DropdownMenu
                  open={showLanguageMenu}
                  onOpenChange={(open) => setShowLanguageMenu(open)}
                >
                  <DropdownMenuTrigger asChild>
                    <div className="flex flex-col">
                      <BsGlobe
                        className="cursor-pointer"
                        size={12}
                        onClick={() => {
                          setShowLanguageMenu(true);
                        }}
                      />
                    </div>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-52" sideOffset={20}>
                    <DropdownMenuLabel>
                      {t("header.PlatformLanguage")}
                    </DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuGroup>
                      <div className="flex flex-col gap-2 px-2">
                        {languagesOptions.map((lang, index) => {
                          const isSelected = lang.value === selectedLanguage;
                          return (
                            <div
                              className="flex flex-row items-center justify-between gap-2"
                              key={index}
                            >
                              <Label htmlFor={"lang-box-" + lang.value}>
                                {lang.name}
                              </Label>
                              <Switch
                                id={"lang-box-" + lang.value}
                                checked={isSelected}
                                disabled={isSelected}
                                onCheckedChange={() =>
                                  saveLanguagePref(lang.value)
                                }
                              />
                            </div>
                          );
                        })}
                      </div>
                    </DropdownMenuGroup>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
              <Link
                href={{
                  pathname: "/settings",
                  query: { locale: router.locale || "en" },
                }}
                className="flex justify-center items-center"
              >
                <div
                  title={t("Setting and preferences")}
                  className="flex justify-center items-center text-sm text-center relative py-2 cursor-pointer rounded-full"
                >
                  <RiSettings5Fill className="text-lg" />
                </div>
              </Link>
              <Popover
                open={showNotificationMenu}
                onOpenChange={(open) => setShowNotificationMenu(open)}
              >
                <PopoverTrigger asChild>
                  <div
                    title={t("header.iconTitle.notification")}
                    className="flex justify-center items-center text-sm cursor-pointer relative"
                    onClick={() => handleNotificationClick(userInfo)}
                  >
                    <FaBell />
                    {notification.length > 0 && showRedDot && (
                      <div className="rounded-xl absolute bottom-[10px] left-[10px]">
                        <div className="w-[10px] h-[10px] rounded-xl  bg-[#FF0000]"></div>
                      </div>
                      // <Dot className="w-[30px] h-[30px] " />
                    )}
                  </div>
                </PopoverTrigger>
                <PopoverContent className="w-screen sm:max-w-lg">
                  <div
                    className="flex w-full justify-end mb-2"
                    onClick={() => setShowNotificationMenu(false)}
                  >
                    <Button size="icon" variant="ghost">
                      <MdClose />
                    </Button>
                  </div>
                  <Tabs
                    defaultValue="deployed-alerts"
                    onValueChange={(val) => setIsStatus(val === "alerts")}
                  >
                    <TabsList className="w-full">
                      <TabsTrigger value="deployed-alerts" className="grow">
                        {/* {t("header.deployedAlerts")} */}
                        {"Deployed Scanner Alerts"}
                      </TabsTrigger>
                    </TabsList>

                    <TabsContent value="deployed-alerts">
                      <Table>
                        {/* @ts-ignore */}
                        <TableCaption className="text-sm text-left my-2">
                          {/* {t("header.notificationHeading")}*/}
                          <p>
                            {"View alerts generated by your deployed scanners."}{" "}
                            <Link
                              href="/deploy?source=deploy"
                              className="underline"
                            >
                              {"Click here"}
                            </Link>{" "}
                            {"to manage scanners"}
                          </p>
                        </TableCaption>
                        <TableHeader>
                          <TableRow>
                            <TableHead>
                              {t("header.iconTitle.notification")}
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {!notification.length && (
                            <TableRow>
                              <TableCell
                                colSpan={2}
                                className="text-center text-xs text-muted-foreground"
                              >
                                {t("header.noNotificationData")}
                              </TableCell>
                            </TableRow>
                          )}
                          {loading ? (
                            <TableRow>
                              <TableCell>
                                <Loader2 className="ml-2 h-5 w-5 animate-spin" />
                              </TableCell>
                            </TableRow>
                          ) : (
                            <ScrollArea className="h-[300px] w-full">
                              {notification.map((item: any, index: number) => (
                                <TableRow
                                  key={index}
                                  className="flex w-full justify-between items-start"
                                >
                                  <TableCell className="flex justify-between items-start w-full gap-2">
                                    <div className="flex flex-col gap-2 w-full">
                                      <p className="text-muted-foreground">
                                        {
                                          item?.scanner_deployment?.strategy
                                            ?.strategy_name
                                        }
                                      </p>
                                      {item?.meta?.length > 0 ? (
                                        <p className="px-2">
                                          {item?.meta?.map(
                                            (meta: string, index: number) => (
                                              <p key={index}>{meta}</p>
                                            )
                                          )}
                                        </p>
                                      ) : (
                                        <p className="px-2">
                                          No alerts generated
                                        </p>
                                      )}
                                    </div>
                                    <p className="text-muted-foreground text-xs whitespace-nowrap">
                                      {formatDateLocal(
                                        item?.created_at,
                                        "DD-MMM-YY HH:mm"
                                      )}
                                    </p>
                                    <Button
                                      variant="ghost"
                                      onClick={() =>
                                        handleViewScanner(
                                          item?.scanner_deployment?.strategy
                                            ?.canvas_data,
                                          item?.scanner_deployment?.strategy
                                            ?.symbol,
                                          item?.scanner_deployment?.strategy
                                            ?.timeframe
                                        )
                                      }
                                      className="my-auto"
                                    >
                                      <div className="flex text-muted-foreground w-full items-center gap-2">
                                        <Eye />
                                        <p className="text-xs">View</p>
                                      </div>
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </ScrollArea>
                          )}
                        </TableBody>
                      </Table>
                      <Pagination
                        totalCount={createdTotalCount}
                        currentPage={currentCreatedPage}
                        changePage={setCurrentCreatedPage}
                        limit={NOTIFICATION_LIMIT}
                      />
                    </TabsContent>
                  </Tabs>
                </PopoverContent>
              </Popover>
              <Button
                variant="ghost"
                size="icon"
                className="h-auto w-fit hover:bg-transparent"
                onClick={() => setDarkTheme(!darkTheme)}
              >
                {darkTheme ? <MdLightMode /> : <MdDarkMode />}
              </Button>
              {/* <input
              autoComplete="off"
              id="profile-image-upload-input"
              type="file"
              className="hidden"
              accept="image/*"
              onChange={(e: any) => onSelectProfileImage(e.target.files)}
            /> */}
              <Label
                htmlFor="profile-image-upload-input"
                className="cursor-pointer"
              >
                <a href={"/profile/" + userInfo?.user?.unique_key}>
                  <Avatar className="rounded-sm">
                    <AvatarImage
                      src={userInfo?.user.profile_image}
                      id="userImage"
                      alt="userImage"
                    />
                    <AvatarFallback>{getNameInitals(userInfo)}</AvatarFallback>
                  </Avatar>
                </a>
              </Label>
            </div>
          </div>
        </div>
        {!props.hideHeader && (
          <div className="3xs:relative relative md:initial lg:initial xl:initial 2xl:initial">
            <div className="flex-grow z-index-9999">
              <div className="flex items-center">
                <div className="mx-auto w-full py-1 ">
                  <div className="flex flex-row justify-between items-center px-3">
                    {/* Header brand logo start*/}
                    <div className="flex flex-row items-center gap-2">
                      <Button
                        onClick={() => setShowSidebar(!showSidebar)}
                        variant="outline"
                        className="px-0 flex items-center justify-center"
                      >
                        <Hamburger
                          size={15}
                          toggled={showSidebar}
                          toggle={setShowSidebar}
                        />
                      </Button>

                      <div className="flex-shrink-0 3xs:max-w-[250px]">
                        <Link
                          href={{
                            pathname: "/build",
                            query: { locale: router.locale || "en" },
                          }}
                        >
                          <Image
                            width={115}
                            height={60}
                            src={
                              darkTheme
                                ? BROKER_LOGO[CURRENT_BROKER].DARK.textLogo
                                : BROKER_LOGO[CURRENT_BROKER].LIGHT.textLogo
                            }
                            alt="alpaca-logo"
                          />
                        </Link>
                      </div>
                      {/* <Badge
                        className="ml-2 text-xs hidden sm:block"
                        variant="secondary"
                      >
                        <a href="/subscription">
                          {userType === "Pro" ? "Pro" : "Free"}
                        </a>
                      </Badge> */}
                      <div className="hidden lg:flex lg:flex-row lg:flex-grow-1 md:px-5 px-3"></div>
                    </div>

                    <div className="hidden md:block">
                      <Popover
                        open={openQuickStrategy}
                        onOpenChange={(isOpen) => {
                          setQuickStrategyModalToggle(isOpen); // Dynamically toggle openQuickStrategy
                          if (!isOpen) {
                            changeScannerType(false); // Reset scanner type when closing
                          }
                        }}
                      >
                        <PopoverTrigger asChild>
                          <Button
                            variant="outline"
                            role="combobox"
                            aria-expanded={openQuickStrategy}
                            onClick={() => setQuickStrategyModalToggle(true)} // Open the modal
                            className="lg:w-96 max-w-2xl justify-between text-muted-foreground text-sm font-semibold"
                          >
                            {value
                              ? frameworks?.find(
                                  (framework: any) => framework.value === value
                                )?.label
                              : t("Quick create - Search by ticker symbol")}
                            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent className="lg:w-96 max-w-2xl p-0">
                          <div className={"w-full"}>
                            <CreateStrategyForm />
                          </div>
                        </PopoverContent>
                      </Popover>
                    </div>

                    {/* Header brand logo end */}
                    <div className="flex flex-row">
                      {/* Funds block start */}
                      <div className="flex lg:flex-row lg:flex-shrink-1 md:px-5">
                        <div className="flex items-center">
                          <div id="user-broker-funds">
                            <div className=" flex flex-row gap-1 md:gap-3 px-3 py-1 md:px-6 h-full  justify-center">
                              <Funds virtualFundsRecharge={() => null} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <ViewModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
          selected={selected}
        />
      </div>
    </>
  );
}
